import { reactive } from 'vue'
import { defineStore } from 'pinia'
import { Tenant } from '@/types';

export const useTenantStore = defineStore('tenantData', () => {
  
  const initialStatsState = {
    data:[]
  }

  const tenants = reactive<Array<Tenant>>([]);

  const tenantData = reactive(initialStatsState);

  function resetStore() {
    Object.assign(tenantData, initialStatsState);
  }

  return { tenantData, resetStore, tenants };
})
